<div class="not-found-container">
  <div class="not-found-content">
    <h1 i18n>404 - Page Not Found</h1>
    <p i18n>The requested page could not be found.</p>
  </div>
</div>

